import { makeStyles } from "@material-ui/core/styles";
import classnames from "classnames";
import PropTypes from "prop-types";
import React from "react";
import { MenuItemLink } from "react-admin";

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.text.secondary,
    paddingTop: "6px",
    paddingLeft: "16px",
    paddingRight: "16px",
    height: "36px",
  },
  active: {
    color: theme.palette.text.primary,
  },
  icon: { minWidth: "40px" },
}));

export function MenuItemExtLink({ classes: classesOverride, ...props }) {
  const classes = useStyles({ classes: classesOverride });

  const handleMenuTap = (e) => {
    (props.onClick && props.onClick(e)) ||
      (props.target && props.target === "_blank" && window.open(props.to)) ||
      (window.location = props.to);
  };

  const { sidebarIsOpen, className, primaryText, leftIcon, dense, to } = props;

  return (
    <MenuItemLink
      component={"a" as any}
      key={primaryText}
      to={to}
      primaryText={primaryText}
      leftIcon={leftIcon}
      onClick={handleMenuTap}
      dense={dense}
      sidebarIsOpen={sidebarIsOpen}
      className={classnames(classes.root, className)}
      title="" /* Prevent tooltip on expand */
    />
  );
}

MenuItemExtLink.propTypes = {
  classes: PropTypes.object,
  className: PropTypes.string,
  leftIcon: PropTypes.element,
  onClick: PropTypes.func,
  primaryText: PropTypes.node,
  staticContext: PropTypes.object,
  to: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default MenuItemExtLink;
